import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { withApollo, Query } from 'react-apollo';
import gql from 'graphql-tag';
class Logout extends Component {
	componentDidMount() {
		// this.props.client.resetStore();
		// window.localStorage.clear();
	}

	// checkVerified = async () => {
	// 	const { client, history } = this.props;
	// 	const { data } = await client.query({
	// 		query: CHECK_VERIFICATION
	// 	});

	// 	if (data.currentUser) {
	// 		console.log(this.state.redirect);
	// 		if (
	// 			data.currentUser.smsVerified &&
	// 			[
	// 				'operating',
	// 				'negative_balance',
	// 				'closed',
	// 				'blacklisted',
	// 				'pending_reactivation',
	// 				'weekly_lease'
	// 			].includes(data.currentUser.status)
	// 		) {
	// 			this.props.logout('/downloadapp');
	// 		} else {
	// 			this.props.logout('/');
	// 		}
	// 	} else {
	// 		this.props.logout('/');
	// 	}
	// };

	render() {
		return (
			<Query query={CHECK_VERIFICATION}>
				{({ loading, error, data, refetch }) => {
					if (loading) {
						return <div />;
					} else if (error) {
						console.log(error);
					}

					if (data.currentUser) {
						if (
							data.currentUser.smsVerified &&
							[
								'operating',
								'negative_balance',
								'closed',
								'blacklisted',
								'pending_reactivation',
								'weekly_lease'
							].includes(data.currentUser.status)
						) {
							this.props.client.resetStore();
							window.localStorage.clear();
							this.props.logout('/downloadapp');
						} else {
							this.props.client.resetStore();
							window.localStorage.clear();
							this.props.logout('/');
						}
					}

					if (this.props.status) {
						if (
							[
								'operating',
								'negative_balance',
								'closed',
								'blacklisted',
								'pending_reactivation',
								'weekly_lease'
							].includes(this.props.status)
						) {
							this.props.client.resetStore();
							window.localStorage.clear();
							this.props.logout('/downloadapp');
						} else {
							this.props.client.resetStore();
							window.localStorage.clear();
							this.props.logout('/');
						}
					} else {
						this.props.client.resetStore();
						window.localStorage.clear();
						this.props.logout('/dashboard');
					}
				}}
			</Query>
		);
	}
}

export default withApollo(Logout);

const CHECK_VERIFICATION = gql`
	{
		currentUser {
			id
			smsVerified
			mobile
			status
		}
	}
`;
// (this.props.status !== 'subscribed' ||
// 								(this.props.status === 'subscribed' &&
// 									data.currentUser.smsVerified))
// ![
// 								'/verify',
// 								'/loginapp',
// 								'/apply',
// 								'/login',
// 								'/dashboard',
// 								'/profile',
// 								'/logout',
// 								'/404'
// 							].includes(this.props.history.location.pathname)
// if (data.currentUser) {
// 						if (
// 							[
// 								'operating',
// 								'negative_balance',
// 								'closed',
// 								'blacklisted',
// 								'pending_reactivation',
// 								'weekly_lease'
// 							].includes(data.currentUser.status)
// 						) {
// 							return <Redirect to="/" />;
// 						}
// 					}
// <Query query={CHECK_VERIFICATION}>
// 				{({ loading, error, data, refetch }) => {
// 					if (loading) return <div />;
// 					if (error) return <Redirect to="/404" />;

// 					return < />;
// 				}}
// 			</Query>



// WEBPACK FOOTER //
// ./src/components/User/Logout.js